import { api } from './api';

/**
 * Авторизация — ОБЫЧНЫЙ CRM-auth (/api/auth/*), не wiki-auth:
 * пользователи бота = сотрудники УК с CRM-учётками. Cookie fib.sid
 * имеет domain=.brasol.ru → залогиненный в CRM попадает сюда без формы.
 */
export interface VkAppUser {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  role: { code: string; name: string; permissions: string[] };
}

export function hasPermission(user: VkAppUser | null, perm: string): boolean {
  if (!user) return false;
  const perms = user.role.permissions;
  return perms.includes('*') || perms.includes(perm);
}

export const authApi = {
  me: () => api.get<{ user: VkAppUser }>('/auth/me'),
  login: (email: string, password: string) =>
    api.post<{ user: VkAppUser }>('/auth/login', { email, password }),
  logout: () => api.post<{ ok: boolean }>('/auth/logout'),
};
